import userStore from '../../stores/user-store.js'
import UserAPI from '../data/user-api-client.js'

export default class UserService {
    static async store (email, password, referral_code) {
        try {
            const user = await UserAPI.store({
                email,
                password,
                referral_code,
            })
            await userStore.setEmail(email)
            return user
        } catch (error) {
            console.error('UserService.store - Error:', error)
            throw error
        }
    }

    static async show () {
        try {
            return await UserAPI.show()
        } catch (error) {
            console.error('UserService.show - Error:', error)
            throw error
        }
    }

    // TENANT-5440: record acceptance of the current ToS + Privacy Policy via
    // POST /user/legal-acceptance, then patch the cached user in userStore so
    // route guards see `legal_acceptance.is_current === true` without a
    // refetch of GET /user.
    static async recordLegalAcceptance () {
        try {
            const {
                data,
            } = await UserAPI.recordLegalAcceptance()

            // The 201 envelope documents `data` as the recorded acceptance
            // row. A missing payload is an API contract error — throw rather
            // than silently fabricating an acceptance (repo non-negotiable:
            // no silent fallbacks); the modal stays up and the error surfaces.
            if (!data || typeof data !== 'object') {
                throw new Error('UserService.recordLegalAcceptance - 201 response carried no acceptance data')
            }

            const user = await userStore.getUser()
            if (user) {
                await userStore.setUser({
                    ...user,
                    legal_acceptance: {
                        ...user.legal_acceptance,
                        ...data,
                        // The row is the audit record; the acceptance we just
                        // recorded is by definition the current one.
                        accepted: true,
                        is_current: true,
                    },
                })
            }

            return data
        } catch (error) {
            console.error('UserService.recordLegalAcceptance - Error:', error)
            throw error
        }
    }

    static async getPartnerOrganizationSlugs () {
        const {
            data,
        } = await UserAPI.getPartnerOrganizationSlugs()
        return data?.organization_slugs ?? []
    }

    static async updateCredentials (currentPassword, newPassword) {
        try {
            return await UserAPI.updateCredentials({
                current_password: currentPassword,
                new_password: newPassword,
            })
        } catch (error) {
            console.error('UserService.updateCredentials - Error:', error)
            throw error
        }
    }

    static async requestPasswordReset (email, reset_link) {
        try {
            return await UserAPI.requestPasswordReset({
                email,
                reset_link,
            })
        } catch (error) {
            console.error('UserService.requestPasswordReset - Error:', error)
            throw error
        }
    }

    static async passwordReset (token, new_password) {
        try {
            return await UserAPI.passwordReset(token, {
                new_password,
            })
        } catch (error) {
            console.error('UserService.passwordReset - Error:', error)
            throw error
        }
    }

    static async requestEmailVerification (redirect_url) {
        try {
            return await UserAPI.requestEmailVerification({
                redirect_url,
            })
        } catch (error) {
            console.error('UserService.requestEmailVerification - Error:', error)
            throw error
        }
    }

    static async verifyEmail (token) {
        try {
            const {
                data,
            } = await UserAPI.verifyEmail(token)
            console.log('UserService.verifyEmail - data:', data)
            return data
        } catch (error) {
            console.error('UserService.verifyEmail - Error:', error)
            throw error
        }
    }

    static async delete (password) {
        try {
            return await UserAPI.delete({
                password,
            })
        } catch (error) {
            console.error('UserService.delete - Error:', error)
            throw error
        }
    }
}
